<template>
  <div class="oreder-modal">
    <el-dialog
      :close-on-click-modal="false"
      title="Add Payment Method"
      :visible="visible"
      width="858px"
      :before-close="handleClose"
    >
      <div class="oreder-modal-wrap">
        <el-form :model="form" label-position="top">
          <el-form-item>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-input
                  type="text"
                  placeholder="First Name"
                  v-model="form.FirstName"
                ></el-input>
              </el-col>
              <el-col :span="8">
                <el-input
                  type="text"
                  placeholder="Midde Name"
                  v-model="form.MiddeName"
                ></el-input>
              </el-col>
              <el-col :span="8">
                <el-input
                  type="text"
                  placeholder="Last Name"
                  v-model="form.LastName"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-input
                  type="text"
                  placeholder="Billing Address ( Line 1 )"
                  v-model="form.Address1"
                ></el-input>
              </el-col>
              <el-col :span="12">
                <el-input
                  type="text"
                  placeholder="Billing Address ( Line 2 )"
                  v-model="form.Address2"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-input
                  type="text"
                  placeholder="Billing  City"
                  v-model="form.City"
                ></el-input>
              </el-col>
              <el-col :span="12">
                <el-select v-model="form.Province" placeholder="State Province">
                  <el-option label="State Province" value="State Province">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-input
                  type="text"
                  v-model="form.code"
                  placeholder="Billing Postal Code"
                ></el-input>
              </el-col>
              <!-- <el-col :span="6"> </el-col> -->
              <el-col :span="12">
                <el-select
                  v-model="form.Country"
                  placeholder="Billing Country/Region"
                >
                  <el-option label="China" value="China"> </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="Credit Card Details" class="card-wrap">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-input
                  type="text"
                  v-model="form.cardNum"
                  placeholder="Card Number"
                ></el-input>
              </el-col>
              <el-col :span="8">
                <el-input
                  type="text"
                  v-model="form.date"
                  placeholder="MM/YY"
                ></el-input>
              </el-col>
              <el-col :span="8">
                <el-input
                  type="text"
                  v-model="form.cvv"
                  placeholder="CVV"
                ></el-input>
              </el-col>
            </el-row>
            <p class="tips">
              Support VISA, MasterCard, American Express, JCB, Dinners Club,
              Discover, and Paypal.
            </p>
            <ul class="card-list">
              <li>
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-Pay_Visa"></use>
                </svg>
              </li>
              <li>
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-Pay_Mastercard"></use>
                </svg>
              </li>
              <li>
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-Pay_UnionPay"></use>
                </svg>
              </li>
              <li>
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-Pay_Express"></use>
                </svg>
              </li>
             
            </ul>
            <el-checkbox v-model="form.radio"
              >Set it as default payment method.</el-checkbox
            >
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">Cancel</el-button>
        <el-button type="primary" @click="visible = false">Add</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible:false,
      form: {
        Address1: "",
        Address2: "",
        FirstName: "",
        MiddeName: "",
        LastName: "",
        date: "",
        code: "",
        Country: "",
        Province: "",
        City: "",
        cardNum: "",
        cvv: "",
        radio: "",
      },
    };
  },
  watch: {
    visible: {
      handler(n, o) {
        this.visible = n;
      },
    },
  },
  props: {},
  methods: {
    handleClose() {
      this.visible = false;
    },
    showChange() {
      this.visible = !this.visible;
    },
  },
};
</script>

<style scoped lang="scss">
.tips {
  margin: 16px 0;
  font-size: 12px;
  color: #5e6d81;
  line-height: 12px;
  word-wrap: break-word;
  word-break: break-all;
}
.card-wrap {
  background: #f5f7fa;
  padding: 20px 24px 32px;
}
.input-box {
  height: 56px;
}
.card-number {
  height: 56px;
  position: relative;
  .label-text {
    position: absolute;
    left: 16px;
    top: 12px;
    font-size: 12px;
    color: #5e6d81;
    line-height: 12px;
    z-index: 100;
  }
}
.card-list {
  height: 16px;
  margin-bottom: 32px;
  li {
    width: 26px;
    height: 16px;
    float: left;
    background: linear-gradient(180deg, #ffffff 0%, #efefef 100%);
    border: 1px solid #cccccc;
    margin-right: 8px;
    .icon {
      width: 24px;
      height: 14px;
      vertical-align: top;
    }
  }
}
</style>
<style lang="scss">
.card-wrap {
  .input-box {
    height: 56px;
    .el-input__inner {
      height: 56px;
    }
  }
  .card-number {
    .el-input {
      position: absolute;
      height: 56px;
      width: 100%;
    }
    .el-input__inner {
      position: absolute;
      top: 0;
      left: 0;
      height: 56px;
      padding-top: 26px;
      line-height: 20px;
    }
  }
  .el-radio__input.is-checked + .el-radio__label,
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #2d3037;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/AddMethod.vue